var fixSearchParams = function (params) {
    return Object.fromEntries(Object.entries(params).filter(function (_a) {
        var value = _a[1];
        return !!value || value === 0;
    }));
};

export { fixSearchParams };
